import { GiftCardModel, GiftCardPaymentStatus, GiftCardStatus, GiftCardViewModel } from 'shared/models'

const fakeGiftCards: GiftCardModel[] = [
  {
    id: 1,
    amount: 3000,
    balance: 0,
    dateTime: new Date().getTime(),
    code: '0000175662833211',
    expiryDate: new Date('2026-04-20').getTime(),
    name: 'Сергей',
    phoneNumber: '+79993310909',
    email: 'semenov1994@gmail.com',
    staffComment: 'Использован для квеста',
    status: GiftCardStatus.Used,
    paymentStatus: GiftCardPaymentStatus.Paid,
    usedDateTime: new Date().getTime()
  },
  {
    id: 2,
    amount: 3000,
    balance: 1000,
    dateTime: new Date().getTime(),
    code: '0000175662833211',
    expiryDate: new Date('2026-04-20').getTime(),
    name: 'Сергей',
    phoneNumber: '+79993310909',
    email: 'semenov1994@gmail.com',
    staffComment: 'Частично использован для квеста',
    status: GiftCardStatus.PartiallyUsed,
    paymentStatus: GiftCardPaymentStatus.Paid,
    usedDateTime: new Date().getTime()
  },
  {
    id: 3,
    amount: 2000,
    balance: 2000,
    dateTime: new Date().getTime(),
    code: '0000175662877131',
    expiryDate: new Date('2026-04-21').getTime(),
    name: 'Степан',
    phoneNumber: '',
    email: 'stepan.ivanov.2020@gmail.com',
    staffComment: '',
    status: GiftCardStatus.Active,
    paymentStatus: GiftCardPaymentStatus.Paid
  },
  {
    id: 4,
    amount: 3000,
    balance: 0,
    dateTime: new Date().getTime(),
    code: '0000175662819080',
    expiryDate: new Date('2026-04-21').getTime(),
    name: 'Антонина',
    phoneNumber: '+79090123311',
    email: '',
    staffComment: '',
    status: GiftCardStatus.Created,
    paymentStatus: GiftCardPaymentStatus.Requested
  }
]

const fakeGiftCardView: GiftCardViewModel = {
  id: 1,
  amount: 3000,
  balance: 1000,
  dateTime: new Date().getTime(),
  code: '0000175662833211',
  expiryDate: new Date('2026-04-20').getTime(),
  name: 'Сергей',
  phoneNumber: '+7 999 331-09-09',
  email: 'semenov1994@gmail.com',
  staffComment: 'Частично использован для квеста',
  status: GiftCardStatus.PartiallyUsed,
  paymentStatus: GiftCardPaymentStatus.Paid,
  usedDateTime: new Date().getTime(),
  pin: 'B1F187',
  usedForOrder: {
    id: '1231',
    customer: {
      id: '1',
      email: 'admin@insidequest.ru',
      name: 'Сергей',
      phoneNumber: '+79007753434'
    },
    mainService: {
      id: '1',
      price: 2000,
      priceId: '1',
      reservation: {
        id: '1',
        persons: 5,
        startTime: new Date(2024, 4, 20).getTime(),
        endTime: new Date(2024, 4, 20).getTime()
      },
      service: {
        id: 7,
        addressId: 1,
        name: 'Квест Пятница 13',
        withReservation: true
      }
    }
  }
}

export { fakeGiftCards, fakeGiftCardView }
